import React from 'react';
import { Field } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import * as dataSeed from '../../shared/DataSeed';

export const Page4Job = ({ errors, touched, values, state, occupations, onOccupationChange, onPositionChange, positions, props, setFieldValue,
    onCorrespondenceProvinceChange }) => (
    <React.Fragment>
        <FormGroup tag="fieldset">
            <legend>Data Pekerjaan</legend>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Pekerjaan</Label>
                        <Field component="select" name="OccupationId"
                            className={errors.OccupationId && touched.OccupationId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onOccupationChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            <option value="2">Private Employee (Karyawan Swasta)</option>
                            <option value="3">Civil Servant (Pegawai Negri)</option>
                            <option value="4">Housewife (Ibu Rumah Tangga)</option>
                            <option value="5">Entrepreneur (Pengusaha)</option>
                            <option value="6">Student (Pelajar)</option>
                            <option value="7">TNI/Police (TNI/Polisi)</option>
                            <option value="8">Retirement (Pensiunan)</option>
                            <option value="9">Teacher (Guru)</option>
                            <option value="1">Others (Lainnya)</option>
                            {/* {occupations.map((occupation, i) =>
                                    <option key={i} value={occupation.Id}>{occupation.Description}</option>
                                )} */}
                        </Field>
                        {errors.OccupationId && touched.OccupationId ? (
                            <FormFeedback>{errors.OccupationId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                {(values.OccupationId === "1") ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Pekerjaan Lainnya</Label>
                            <Input tag={Field} type="text" name="OccupationOthers" bsSize="sm" disabled={values.OccupationId !== "1"}
                                className={errors.OccupationOthers && touched.OccupationOthers ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            />
                            {errors.OccupationOthers && touched.OccupationOthers ? (
                                <FormFeedback>{errors.OccupationOthers}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col>
                    : null}
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Posisi </Label>
                        <Input tag={Field} type="text" name="PositionText" bsSize="sm"
                            className={errors.PositionText && touched.PositionText ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        />
                        {errors.PositionText && touched.PositionText ? (
                            <FormFeedback>{errors.PositionText}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Bidang Usaha</Label>
                        <Input tag={Field} type="text" name="BusinessFieldText" bsSize="sm"
                            className={errors.BusinessFieldText && touched.BusinessFieldText ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'} />
                        {errors.BusinessFieldText && touched.BusinessFieldText ? (
                            <FormFeedback>{errors.BusinessFieldText}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md="8">
                    <FormGroup>
                        <Label>Nama Tempat Bekerja/Usaha/Sekolah<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="text" name="CompanyName" bsSize="sm" maxLength="30"
                            invalid={errors.CompanyName && touched.CompanyName} />
                        {errors.CompanyName && touched.CompanyName ? (
                            <FormFeedback>{errors.CompanyName}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Penghasilan / Tahun<span className="text-danger">*</span></Label>
                        <Field component="select" name="IncomePerAnnumId"
                            className={errors.IncomePerAnnumId && touched.IncomePerAnnumId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.incomePerAnnums.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.IncomePerAnnumId && touched.IncomePerAnnumId ? (
                            <FormFeedback>{errors.IncomePerAnnumId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Penghasilan<span className="text-danger">*</span></Label>
                        <Field component="select" name="FundSourceId"
                            className={errors.FundSourceId && touched.FundSourceId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.fundSources.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.FundSourceId && touched.FundSourceId ? (
                            <FormFeedback>{errors.FundSourceId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Penghasilan Lainnya </Label>
                        <Input tag={Field} type="text" name="FundSourceOthers" bsSize="sm" disabled={values.FundSourceId !== "1"}
                            className={errors.FundSourceOthers && touched.FundSourceOthers ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        ></Input>
                        {errors.FundSourceOthers && touched.FundSourceOthers ? (
                            <FormFeedback>{errors.FundSourceOthers}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Tujuan Investasi<span className="text-danger">*</span></Label>
                        <Field component="select" name="InvestmentObjective"
                            className={errors.InvestmentObjective && touched.InvestmentObjective ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.investmentObjectives.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.InvestmentObjectiveId && touched.InvestmentObjectiveId ? (
                            <FormFeedback>{errors.InvstmentObjective}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Lama Bekerja/Usaha (tahun)</Label>
                        <Input tag={Field} type="tel" name="LengthOfWork" bsSize="sm"
                            invalid={errors.LengthOfWork && touched.LengthOfWork} />
                        {errors.LengthOfWork && touched.LengthOfWork ? (
                            <FormFeedback>{errors.LengthOfWork}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <legend>Alamat Pekerjaan</legend>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label>Alamat Tempat Bekerja/Usaha/Sekolah<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="text" name="CompanyAddress" bsSize="sm" id="CompanyAddress"
                            invalid={errors.CompanyAddress && touched.CompanyAddress} maxLength={30} />
                        {errors.CompanyAddress && touched.CompanyAddress ? (
                            <FormFeedback>{errors.CompanyAddress}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>

            </Row>
            <Row>
            <Col md="4" xs="4">
                    <FormGroup>
                        <Label>Kode Area<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="text" name="CompanyAreaPhoneNo" bsSize="sm"
                            invalid={errors.CompanyAreaPhoneNo && touched.CompanyAreaPhoneNo} />
                        {errors.CompanyAreaPhoneNo && touched.CompanyAreaPhoneNo ? (
                            <FormFeedback>{errors.CompanyAreaPhoneNo}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4" xs="8">
                    <FormGroup>
                        <Label>No Telepon Tempat Bekerja/Usaha/Sekolah<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="number" name="CompanyPhoneNumber" bsSize="sm"
                            invalid={errors.CompanyPhoneNumber && touched.CompanyPhoneNumber} />
                        {errors.CompanyPhoneNumber && touched.CompanyPhoneNumber ? (
                            <FormFeedback>{errors.CompanyPhoneNumber}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col>
                    <div class="alert alert-dark">Jika ingin melakukan perubahan data selain data di atas, silahkan menghubungi customer service kami di customerservice@juc.co.id atau 021-83788900</div></Col>
            </Row>
        </FormGroup>

        {/* END: Data Pekerjaan */}
    </React.Fragment>
)



// WEBPACK FOOTER //
// ./src/components/PengkinianData/Page4Job.js